import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'festivos',
})
export class FestivosPipe implements PipeTransform {

  transform(items: any[], filter: { menu: string }) {

    if (items) {

      if (filter.menu) {
        items = items.filter((item) => filter.menu === 'pendientes' ? item.id_estado === 0 : item.id_estado === 1);
      }

      return items;

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/festivos/festivos.ts